module.exports = __webpack_public_path__ + "img/icon_more.8233ada4.svg";